import circleXIconUrl from '@/assets/icons/circle-x-gray.svg'
import searchIconUrl from '@/assets/icons/search.svg'

import {
  ClearButton,
  SearchIconWrapper,
  SearchInputBox,
  SearchInputWrapper,
  SearchValueText,
} from './SearchInputDisplay.styles'

interface SearchInputDisplayProps {
  /** 사용자가 검색한 주소 — 인풋에 그대로 표시 (read-only display) */
  address: string
  /** ⓧ clear 클릭 시 — 검색 화면(searching step)으로 복귀 */
  onClear: () => void
}

/**
 * 결과 화면(수거 가능/불가능) 공통 검색 인풋 — 검색어 표시 + ⓧ clear.
 *
 * 인풋 자체는 read-only display. 사용자가 ⓧ로 비우면 검색 화면으로 복귀하는 흐름.
 * styles는 UnavailableResultStep.styles 재활용 — 구조 동일.
 */
export default function SearchInputDisplay({ address, onClear }: SearchInputDisplayProps) {
  return (
    <SearchInputWrapper>
      <SearchInputBox>
        <SearchIconWrapper>
          <img
            src={searchIconUrl}
            alt=''
            width={24}
            height={24}
          />
        </SearchIconWrapper>
        <SearchValueText>{address}</SearchValueText>
        <ClearButton
          type='button'
          onClick={onClear}
          aria-label='주소 지우기'>
          <img
            src={circleXIconUrl}
            alt=''
            width={24}
            height={24}
          />
        </ClearButton>
      </SearchInputBox>
    </SearchInputWrapper>
  )
}
